import React from 'react';
import {Row, Col} from 'react-bootstrap';


import Liquid from '../assets/Products/Water.png'
import Oral from '../assets/Products/Oral.png';
import Paste from '../assets/Products/Paste.png';
import Powder from '../assets/Products/Powder.png';
import PowderUS from '../assets/Products/PowderUS.jpg';
import Wipe from '../assets/Products/Wipes.png';

import Biotrate from '../assets/Products/Biotrate.png';
import SDS from '../assets/Products/SDSbutton.jpg';

import SDSWipe from '../assets/Products/sds/ca/en/dental_wipe.pdf';
import SDSOral from '../assets/Products/sds/ca/en/oral_spray.pdf';
import SDSPowder from '../assets/Products/sds/ca/en/powder_additive.pdf';
import SDSPowderUS from '../assets/Products/sds/us/en/powder_additive.pdf';

import SDSPaste from '../assets/Products/sds/ca/en/toothpaste.pdf';
import SDSLiquid from '../assets/Products/sds/ca/en/water_additive.pdf';
import SDSPasteUS from '../assets/Products/sds/us/en/toothpaste.pdf';
import PasteUS from '../assets/Products/PasteUS.jpg';
import Detailer from '../assets/Products/Detailer.png';
import Detailer_Doc from '../assets/Products/Detailer.pdf'


import Brochure from '../assets/Products/Brochure.png';
import Brochure_Doc from '../assets/Products/Brochure.pdf';

import SDSRawHides from '../assets/Products/sds/us/en/rawhides.pdf'
import RawHideLarge from '../assets/Products/RawhideLarge.jpg';
import RawHideMedium from '../assets/Products/RawhideMedium.jpg';

import '../css/Products.css';
import Page from "./Page";




class ProductPreview extends Page{

  componentDidMount() {
    document.title = "Products | Vetradent™";
  }

  render(){
    var curr_product_image;
    var curr_product_sds;
    var powder_image_for_country;
    var powder_sds;
    let paste_image_for_country, paste_sds;
    if(this.props.Settings.country === 'CA'){
      powder_image_for_country = Powder;
      powder_sds = SDSPowder;
      paste_image_for_country = Paste;
      paste_sds = SDSPaste;
    }else {
      powder_image_for_country = PowderUS;
      powder_sds = SDSPowderUS;
      paste_image_for_country = PasteUS;
      paste_sds = SDSPasteUS;
    }

    switch(this.props.CurrentProduct){
      case 0:
        curr_product_image = Liquid;
        curr_product_sds = SDSLiquid;
        break;
      case 1:
        curr_product_image = Oral;
        curr_product_sds = SDSOral;
        break;
      case 2:
        curr_product_image = paste_image_for_country;
        curr_product_sds = paste_sds;
        break;
      case 3:
        curr_product_image = Wipe;
        curr_product_sds = SDSWipe;
        break;
      case 4:
        curr_product_image = powder_image_for_country;
        curr_product_sds = powder_sds;
        break;
      case 5:
        curr_product_image = RawHideMedium;
        curr_product_sds = SDSRawHides;
        break;
      case 6:
        curr_product_image = RawHideLarge;
        curr_product_sds = SDSRawHides;
        break;
      default:
    }

    return(
      <div className="product-preview">
        <img src = {curr_product_image} className = "product-preview-image" alt="Product Preview"/>
        <h2 className="product-preview-headline">{this.contentParser("headline")}</h2>
        <p className="neutral-text">{this.contentParser("product-use")}
          <span className = "product-closer"> {this.contentParser("product-closer")} </span>
        </p>

        <div className = "custom-table">
          <Row className="table-row">
            <Col xs={4} className="no-padding">
              <p>{this.contentParser("header1")}</p>

            </Col>
            <Col xs={8} className="no-padding">
              <p>{this.contentParser("product-ingredients")}</p>
            </Col>
          </Row>
          <Row className="table-row">
            <Col xs={4} className="no-padding">
              <p>{this.contentParser("header2")}</p>
            </Col>
            <Col xs={8} className="no-padding">
              <p>{this.contentParser("product-package")}</p>
            </Col>
          </Row>
          <Row className="table-row">
            <Col xs={4} className="no-padding" >
              <p>{this.contentParser("header3")}</p>
            </Col>
            <Col xs={8} className="no-padding">
              <a href={curr_product_sds} target="_blank">
                <img className = "SDS" src={SDS} alt={"Documents Download"} />
              </a>
            </Col>
          </Row>

        </div>
      </div>
    );
  }

}

class ProductTab extends Page{

  render(){
    var class_name;
    var product_image;

    let powder_image_for_country, paste_image_for_country;
    if(this.props.Settings.country === 'CA'){
      powder_image_for_country = Powder;
      paste_image_for_country = Paste;
    }else {
      powder_image_for_country = PowderUS;
      paste_image_for_country = PasteUS;
    }

    if(this.props.CurrProduct === this.props.ProductID){
      class_name = "active-product-tab";
    }else{
      class_name = "inactive-product-tab";
    }

    switch(this.props.ProductID){
      case 0:
        product_image = Liquid;
        break;
      case 1:
        product_image = Oral;
        break;
      case 2:
        product_image = paste_image_for_country;
        break;
      case 3:
        product_image = Wipe;
        break;
      case 4:
        product_image = powder_image_for_country;
        break;
      case 5:
        product_image = RawHideMedium;
        break;
      case 6:
        product_image = RawHideLarge;
        break;
      default:
      //
    }


    return(
      <div className={class_name}>
        <div className={"flexbox"}>
          <div className="product-tab-image">
            <img  src = {product_image} alt = "Product" />
          </div>
          <div className = "product-tab-text" xs={8}>
            <h2 className="product-tab-headline">{this.contentParser("headline")}</h2>
            <h2 className="neutral-text">{this.contentParser("subtext")}</h2>
            <p>{this.contentParser("product-tag")}</p>
          </div>
        </div>
      </div>
    );
  }
}

class Products extends Page{

  constructor(props){
    super(props);
    this.state = {
      curr_product:0
    };

    this.handleProductClick = this.handleProductClick.bind(this);
    this.goToHomePage = this.goToHomePage.bind(this);
  }

  goToHomePage(){
    this.props.setPage("home")
  }

  handleProductClick(e){
    var curr_product;
    var state = this.state;
    curr_product = parseInt(e.currentTarget.getAttribute("data"), 10);
    state.curr_product = curr_product;
    this.setState({state});
  }

  render(){
    const { Settings } = this.props;
    let canadianProducts = [];
    let americanProducts = [];

    if (Settings.country === 'CA') {
      //canadianProducts['toothpaste'] = <React.Fragment/>
    }


    if (Settings.country === "US") {
      americanProducts["RawHideMedium"] =
        <a data = "5"
           onClick = {this.handleProductClick}
        >
          <ProductTab
            CurrProduct = {this.state.curr_product}
            ProductID = {5}
            Content = {this.props.Products[5].content}
            Settings={this.props.Settings}
          />
        </a>;
      americanProducts["RawHideLarge"] =
        <a data = "6"
           onClick = {this.handleProductClick}
        >
          <ProductTab
            CurrProduct = {this.state.curr_product}
            ProductID = {6}
            Content = {this.props.Products[6].content}
            Settings={this.props.Settings}
          />
        </a>;
    }

    return(
      <div className = "products">
        <div className = "chunk-white">
          <div className="breadcrumbs"><a aria-label="home page" onClick={this.goToHomePage} className="breadcrumb-home">Home</a><div className="breadcrumb-page"> &nbsp; Products</div></div>

          <Row>
            <Col xs={3}>
              <img className="biotrate-image" src = {Biotrate} alt="Biotrate Logo" />
            </Col>
            <Col className= "dechra-text" xs ={9}>
              <h1 className = "product-headline">{this.contentParser("headline")} </h1>
              <p>
                <span className="accent-product">Vetradent™ </span>
                {this.contentParser("headline-text")}
              </p>
            </Col>
          </Row>

          <Row className="product-tab-list">
            <Col xs={12} sm={12} md={7}>
              <a onClick = {this.handleProductClick} data = "0">
                <ProductTab
                  CurrProduct = {this.state.curr_product}
                  ProductID = {0}
                  Content = {this.props.Products[0].content}
                  Settings={this.props.Settings}
                />
              </a>
              <a data = "1"
                 onClick = {this.handleProductClick}>
                <ProductTab
                  CurrProduct = {this.state.curr_product}
                  ProductID = {1}
                  Content = {this.props.Products[1].content}
                  Settings={this.props.Settings}
                />
              </a>
              <a data = "2"
                 onClick = {this.handleProductClick}>
                <ProductTab
                  CurrProduct = {this.state.curr_product}
                  ProductID = {2}
                  Content = {this.props.Products[2].content}
                  Settings={this.props.Settings}
                />
              </a>
              <a data = "3"
                 onClick = {this.handleProductClick}>
                <ProductTab
                  CurrProduct = {this.state.curr_product}
                  ProductID = {3}
                  Content = {this.props.Products[3].content}
                  Settings={this.props.Settings}
                />
              </a>
              <a data = "4"
                 onClick = {this.handleProductClick} >
                <ProductTab
                  CurrProduct = {this.state.curr_product}
                  ProductID = {4}
                  Content = {this.props.Products[4].content}
                  Settings={this.props.Settings}
                />
              </a>
              {americanProducts['RawHideMedium']}
              {americanProducts['RawHideLarge']}
            </Col>
            <Col xs={12} sm={12} md={5} id={"product_details"}>
              <ProductPreview
                CurrentProduct = {this.state.curr_product}
                Content = {this.props.Products[this.state.curr_product].content}
                Settings={this.props.Settings}
              />
            </Col>
          </Row>
          {Settings.country === 'US' &&
          <div>
            <div className = "custom-hr"></div>
            <h3 className = "dark-grey-headline">{this.contentParser("resources-headline")}</h3>
            <Row>
              <Col xs={4}>
                <a href={Detailer_Doc} target="_blank">
                  <img className = "additional-resources-link" src = {Detailer} alt="Vetradent Detailer" />
                </a>
              </Col>
              <Col xs={4}>
                <a href={Brochure_Doc} target="_blank">
                  <img className = "additional-resources-link" src = {Brochure} alt="Betradent Client Brochure" />
                </a>
              </Col>
            </Row>
          </div>
          }
        </div>
      </div>
    )

  }
}

export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.js